export default __webpack_public_path__ + "static/media/bike_icon.00f677a8.svg";